
import axios from "axios";
import { API_VERSION, HOST_SERVER } from "../settings/constants";

export const API = axios.create({baseURL: HOST_SERVER + API_VERSION})


// // Add a response interceptor
// API.interceptors.response.use(
//     response => {
//       return response.data;
//     },
//     error => {
//       return Promise.reject(error);
//     }
//   );
  
//   // Add a request interceptor
//   API.interceptors.request.use(
//     config => {
//       // Modify the request config here
//       return config;
//     },
//     error => {
//       return Promise.reject(error);
//     }
//   );
  
//   export default API;
